/* SALVIA — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* Aparición suave al hacer scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* Barra de compra fija en móvil: aparece cuando el botón principal sale de pantalla */
  function initStickyBuy() {
    var bar = document.querySelector('[data-mt-sticky]');
    if (!bar) return;
    var mainBtn = document.querySelector('.product-form__submit[name="add"]');
    var trigger = bar.querySelector('[data-mt-sticky-btn]');
    var priceEl = bar.querySelector('[data-mt-sticky-price]');
    if (!mainBtn || !trigger) { bar.remove(); return; }

    function syncState() {
      var disabled = mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true';
      trigger.disabled = disabled;
      var label = mainBtn.querySelector('span');
      if (label && label.textContent.trim()) trigger.querySelector('span').textContent = label.textContent.trim();
      var mainPrice = document.querySelector('.product .price .price-item--sale, .product .price .price-item--regular');
      var sale = document.querySelector('.product .price--on-sale .price-item--sale');
      var current = sale || mainPrice;
      if (priceEl && current && current.textContent.trim()) priceEl.textContent = current.textContent.trim();
    }

    trigger.addEventListener('click', function () {
      if (trigger.disabled) return;
      mainBtn.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past);
          bar.setAttribute('aria-hidden', past ? 'false' : 'true');
          if (past) syncState();
        });
      }).observe(mainBtn);
    }
    new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });
  }


  /* Producto estrella de la portada: fotos y colores */
  function initSpot() {
    document.querySelectorAll('[data-mt-spot]').forEach(function (spot) {
      var main = spot.querySelector('.mt-spot__main-img');
      spot.querySelectorAll('[data-mt-spot-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = btn.getAttribute('data-mt-spot-thumb'); }
          spot.querySelectorAll('[data-mt-spot-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        });
      });
      var dataEl = spot.querySelector('[data-mt-spot-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var labels = JSON.parse(spot.querySelector('[data-mt-spot-labels]').textContent);
      var idInput = spot.querySelector('[data-mt-spot-id]');
      var price = spot.querySelector('[data-mt-spot-price]');
      var add = spot.querySelector('[data-mt-spot-add]');
      var fmt = function (cents) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2) + ' €'; }
      };
      spot.querySelectorAll('[data-mt-spot-opt]').forEach(function (input) {
        input.addEventListener('change', function () {
          var chosen = [];
          spot.querySelectorAll('.mt-spot__option').forEach(function (fs, i) {
            var c = fs.querySelector('input:checked');
            chosen[i] = c ? c.value : null;
            var lbl = spot.querySelector('[data-mt-spot-label="' + i + '"]');
            if (lbl && c) lbl.textContent = c.value;
          });
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
          if (!match) return;
          idInput.value = match.id;
          if (price) price.textContent = fmt(match.price);
          add.disabled = !match.available;
          add.querySelector('span').textContent = match.available ? labels.add : labels.soldout;
          if (match.featured_image && main) { main.removeAttribute('srcset'); main.src = match.featured_image.src; }
        });
      });
    });
  }


  /* Cabecera: estado compacto al bajar */
  function initHeaderScroll() {
    var root = document.documentElement, ticking = false;
    function update() { root.classList.toggle('mt-scrolled', window.scrollY > 40); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Vídeos: se reproducen en silencio al verse, se pausan al salir; botones reales de play y sonido */
  function initVideos(root) {
    (root || document).querySelectorAll('[data-mt-videos] .mt-vid__card').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v || v.dataset.mtInit) return;
      v.dataset.mtInit = '1'; v.muted = true; v.removeAttribute('controls');
      var sync = function () { card.classList.toggle('is-playing', !v.paused); card.classList.toggle('has-sound', !v.muted); };
      v.addEventListener('play', sync); v.addEventListener('pause', sync); v.addEventListener('volumechange', sync);
      card.querySelector('[data-mt-vid-toggle]').addEventListener('click', function () { if (v.paused) { v.play(); } else { v.pause(); card.dataset.mtUserPaused = '1'; } });
      card.querySelector('[data-mt-vid-sound]').addEventListener('click', function () { v.muted = !v.muted; if (!v.muted && v.paused) v.play(); });
      if (!reduceMotion && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.6 && !card.dataset.mtUserPaused) { v.play().catch(function () {}); }
            else if (!e.isIntersecting || e.intersectionRatio < 0.3) { v.pause(); }
          });
        }, { threshold: [0, 0.3, 0.6, 1] }).observe(v);
      }
      sync();
    });
  }

  function init() {
    initHeaderScroll();
    initVideos();
    initReveal();
    initStickyBuy();
    initSpot();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de Shopify: re-inicializar al añadir o recargar secciones */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initVideos(e.target); });
})();

/* ===== Ficha de producto: packs y plazo de entrega ===== */
(function () {
  /* Packs: elegir 1 ud / 2 uds / pack con otro producto */
  if (!customElements.get('mt-bundles')) {
    customElements.define('mt-bundles', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        if (!this.form) return;
        this.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) this.select(e.target); });
        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('submit', this.onSubmit, true);
        const checked = this.querySelector('input:checked');
        if (checked) this.select(checked);
      }
      disconnectedCallback() { document.removeEventListener('submit', this.onSubmit, true); }
      qtyInput() {
        let q = this.form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + this.form.id + '"]');
        if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; this.form.appendChild(q); }
        return q;
      }
      select(input) {
        this.querySelectorAll('.mt-bun__opt').forEach((o) => o.classList.toggle('is-active', o.contains(input)));
        this.qtyInput().value = input.dataset.qty || 1;
        var box = this.querySelector('[data-mt-box]');
        if (box) {
          box.querySelector('[data-mt-box-qty]').textContent = '×' + (input.dataset.qty || 1);
          box.querySelector('[data-mt-box-total]').textContent = input.dataset.total || '';
          box.querySelector('[data-mt-box-sep]').textContent = input.dataset.sep || '';
        }
      }
      async onSubmit(e) {
        if (e.target !== this.form) return;
        const sel = this.querySelector('input:checked');
        if (!sel || !sel.dataset.packVariant) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = this.form.querySelector('[name="add"]');
        const mainId = this.form.querySelector('input[name="id"]').value;
        if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
        const drawer = document.querySelector('cart-drawer');
        try {
          const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(mainId), quantity: 1 }, { id: Number(sel.dataset.packVariant), quantity: 1 }],
              sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
              sections_url: window.location.pathname
            })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || 'error');
          if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } catch (err) {
          window.location.href = '/cart/' + mainId + ':1,' + sel.dataset.packVariant + ':1';
        } finally {
          if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        }
      }
    });
  }

  /* Plazo de entrega: fechas reales desde hoy + cuenta atrás hasta la hora de corte */
  var MESES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DIAS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return DIAS[d.getDay()] + ', ' + MESES[d.getMonth()] + ' ' + d.getDate(); }
  function initShip(root) {
    (root || document).querySelectorAll('[data-mt-ship]').forEach(function (el) {
      var min = +el.dataset.min, max = +el.dataset.max, prep = +el.dataset.prep, cut = +el.dataset.cutoff || 24;
      function render() {
        var now = new Date();
        var base = new Date(now);
        var cutoff = new Date(now); cutoff.setHours(cut === 24 ? 23 : cut, cut === 24 ? 59 : 0, 59, 0);
        if (now > cutoff) base = addDays(now, 1);
        var a = addDays(base, min), b = addDays(base, max);
        var range = a.getMonth() === b.getMonth() ? MESES[b.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() : MESES[a.getMonth()] + ' ' + a.getDate() + ' – ' + MESES[b.getMonth()] + ' ' + b.getDate();
        var txt = 'between ' + MESES[a.getMonth()] + ' ' + a.getDate() + ' and ' + MESES[b.getMonth()] + ' ' + b.getDate();
        var r = el.querySelector('[data-mt-ship-range]'); if (r) r.textContent = txt;
        el.querySelectorAll('[data-mt-ship-d]').forEach(function (s) {
          var k = s.dataset.mtShipD;
          if (k === '0') s.textContent = now > cutoff ? 'Tomorrow' : 'Today';
          else if (k === 'prep') s.textContent = fmt(addDays(base, Math.max(prep, 1)));
          else if (k === 'range') s.textContent = range;
        });
        var cd = el.querySelector('[data-mt-ship-cd]');
        if (cd) {
          var ms = cutoff - now;
          cd.textContent = 'Order today';
        }
      }
      render();
      if (!el._mtTimer) el._mtTimer = setInterval(render, 30000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initShip(); });
  else initShip();
  document.addEventListener('shopify:section:load', function (e) { initShip(e.target); });
})();

/* ===== Carrito: «Añade también» (complementos) ===== */
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-mt-up-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = drawer && drawer.contains(btn);
    try {
      var res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.mtUpAdd), quantity: 1 }],
          sections: inDrawer ? 'cart-drawer,cart-icon-bubble' : undefined,
          sections_url: window.location.pathname
        })
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || 'error');
      if (inDrawer && data.sections) drawer.renderContents(data);
      else window.location.reload();
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.querySelector('span') && (btn.querySelector('span').textContent = 'Agotado');
    }
  });
})();

/* Antes y después: el deslizador mueve la línea */
(function () {
  function initBA(root) {
    (root || document).querySelectorAll('[data-mt-ba]').forEach(function (f) {
      var r = f.querySelector('.mt-ba__range');
      if (!r || r._mt) return; r._mt = true;
      r.addEventListener('input', function () { f.style.setProperty('--pos', r.value + '%'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initBA(); }); else initBA();
  document.addEventListener('shopify:section:load', function (e) { initBA(e.target); });
})();
